import { defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79bebe88"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value", "onKeydown"]

import { ref } from 'vue'
import { AsyncUtil } from './AsyncUtil'


export default /*#__PURE__*/_defineComponent({
  __name: 'InPlaceTextEdit',
  props: {
    modelValue: {},
    required: { type: Boolean }
  },
  emits: [
  'update:modelValue',
],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





__expose({
  edit,
  save,
  cancel,
})

const showFocusRef = ref(false)
const isEditing = ref(false)
const originalValue = ref('')
const inputRef = ref<HTMLInputElement>()

function onBlur() {
  endEditing(true)
}

function onClick() {
  if (!isEditing.value) {
    edit()
  }
}

function onEnter() {
  if (isEditing.value) {
    save()
  }
  else {
    edit()
  }
}

function onSpace() { edit() }

function edit() {
  if (inputRef.value && !isEditing.value && !inputRef.value.disabled) {
    isEditing.value = true
    originalValue.value = inputRef.value.value
    inputRef.value.removeAttribute('readonly')
  }
}

function save() { endEditing(true) }
function cancel() { endEditing(false)}

async function endEditing(save: boolean) {
  if (inputRef.value && isEditing.value) {
    if (save && props.required && !inputRef.value.value) {
      inputRef.value.classList.add('rejected')
      await AsyncUtil.delay(500)
      inputRef.value.classList.remove('rejected')
      return
    }

    isEditing.value = false
    inputRef.value.setAttribute('readonly', 'true')
    showFocusRef.value = false
    if (save) {
      emit('update:modelValue', inputRef.value.value)
    }
    else {
      inputRef.value.value = originalValue.value
    }
   
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    type: "text",
    ref_key: "inputRef",
    ref: inputRef,
    value: _ctx.modelValue,
    readonly: "",
    class: _normalizeClass(["form-control in-place", { 'visible-focus': showFocusRef.value }]),
    "aria-describedby": "edit-instructions",
    onBlur: onBlur,
    onClick: onClick,
    onKeydown: [
      _cache[0] || (_cache[0] = _withKeys(($event: any) => (showFocusRef.value = true), ["tab"])),
      _withKeys(_withModifiers(onEnter, ["prevent"]), ["enter"]),
      _withKeys(onSpace, ["space"]),
      _cache[2] || (_cache[2] = _withKeys(($event: any) => (endEditing(false)), ["escape"]))
    ],
    onMousedown: _cache[1] || (_cache[1] = ($event: any) => (showFocusRef.value = false))
  }, null, 42, _hoisted_1))
}
}

})